import React, { Component } from 'react';
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Dropzone from "react-dropzone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { connect } from "react-redux";
import { createCase, getPortalSettings } from "../../redux/actions/UserActions";
import Loading from '../Loader/Loader';
import { Link } from 'react-router-dom';
import ErrorPage from '../Error/ErrorPage';
import { withTranslation } from 'react-i18next';

const MAX_TOTAL_MB = 500;

class CreateCase extends Component {
    constructor(props) {
        super(props);
        const subMarketSourceValues = props.location.state?.subMarketSourceValues || [];
        
        this.state = {
            description: "",
            claimNumber: "",
            counterPartyFirstName: "",
            counterPartySurname: "",
            birthDate: "",
            counterPartyRef: "",
            files: [],
            validtoUpload: true,
            descriptionError: false,
            claimNumberError: false,
            errorMessage: false,
            allData: props.location.state ? props.location.state.allFormsData : [],
            marketSourceId: props.location.state?.marketSourceId || localStorage.getItem('marketSourceId') || '',
            success: false,
            isauthorized: false,
            createCaseHeader: localStorage.getItem("createCaseHeader"),
            createCaseFormInfo: localStorage.getItem("createCaseFormInfo"),
            portallogo: localStorage.getItem("publicportallogo"),
            showInvalid: false,
            subMarketSourceValues: subMarketSourceValues,
            selectedSubMarkets: '00000000-0000-0000-0000-000000000000'
        };
    }

    componentDidMount() {
        if (!Array.isArray(this.state.allData) || this.state.allData.length === 0) {
            this.props.history.replace('/CreateClient');
            return;
        }
        this.props.getPortalSettings();
    }

    componentDidUpdate(prevProps, prevState) {
        const newPortallogo = localStorage.getItem('publicportallogo');
        const newCreateCaseHeader = localStorage.getItem("createCaseHeader");
        const newCreateCaseFormInfo = localStorage.getItem("createCaseFormInfo");
     
        if (
            prevState.portallogo !== newPortallogo ||
            prevState.createCaseHeader !== newCreateCaseHeader ||
            prevState.createCaseFormInfo !== newCreateCaseFormInfo
        ) {
            this.setState({
                portallogo: newPortallogo,
                createCaseHeader: newCreateCaseHeader,
                createCaseFormInfo: newCreateCaseFormInfo,
            });
        }
     
        if (this.props.createcasedata !== prevProps.createcasedata) {
            if (this.props.createcasedata && this.props.createcasedata.Success) {
                this.setState({ success: true });
                this.props.history.push({
                    pathname: '/CreateCaseSuccess',
                    isauthorized: true
                });
            } else if (this.props.createcasedata && !this.props.createcasedata.Success) {
                this.setState({
                    showInvalid: true
                });
            }
        }
    }

    handleDescription = (e) => {
        this.setState({
            description: e.target.value,
            descriptionError: false
        });
    };

    handleClaimNumber = (e) => {
        this.setState({
            claimNumber: e.target.value,
            claimNumberError: false
        });
    };

    handleCounterPartyFirstName = (e) => {
        this.setState({
            counterPartyFirstName: e.target.value
        });
    };

    handleCounterPartySurname = (e) => {
        this.setState({
            counterPartySurname: e.target.value
        });
    };

    handleDateOfBirth = (e) => {
        this.setState({
            birthDate: e.target.value
        });
    };

    handleCoounterPartyRef = (e) => {
        this.setState({
            counterPartyRef: e.target.value
        });
    };

    handleSubMarketChange = (e) => {
        this.setState({ selectedSubMarkets: e.target.value });
    };

    handleCreateFormSubmit = () => {
        const { description, claimNumber, counterPartyFirstName, counterPartySurname, counterPartyRef, files, allData, marketSourceId, selectedSubMarkets } = this.state;
        
        if (!description && !claimNumber) {
            this.setState({
                descriptionError: true,
                claimNumberError: true,
                errorMessage: true
            });
            return;
        }

        if (!description) {
            this.setState({
                descriptionError: true,
                errorMessage: true
            });
            return;
        }

        if (!claimNumber) {
            this.setState({
                claimNumberError: true,
                errorMessage: true
            });
            return;
        }

        const clients = allData.map(client => ({
            firstName: client.firstName,
            lastName: client.lastName,
            email: client.email,
            phoneNumber: client.number,
            birthDate: client.birthDate ? moment(client.birthDate).toISOString() : "",
            streetName: client.streetName,
            postalcode: client.postalcode,
            city: client.city
        }));

        const formData = new FormData();
        formData.append('marketSourceId', marketSourceId);
        formData.append('description', description);
        formData.append('claimNumber', claimNumber);
        formData.append('counterPartFirstName', counterPartyFirstName);
        formData.append('counterPartLastName', counterPartySurname);
        formData.append('counterPartRefNo', counterPartyRef);
        files.forEach((f) => formData.append("Files", f));
        formData.append('ClientsJson', JSON.stringify(clients));
        formData.append("subMarketSourceId", selectedSubMarkets);
        
        this.props.createCase(formData);

        this.setState({
            errorMessage: false,
            descriptionError: false,
            claimNumberError: false
        });
    };

    onDrop = (newFiles) => {
        const existingNames = new Set(this.state.files.map(f => f.name));
        const updatedFiles = [...this.state.files];

        for (let i = 0; i < newFiles.length; i++) {
            const file = newFiles[i];
            const originalName = file.name;

            if (!existingNames.has(originalName)) {
                updatedFiles.push(file);
                existingNames.add(originalName);
                continue;
            }

            const dotIndex = originalName.lastIndexOf('.');
            const base = dotIndex !== -1 ? originalName.slice(0, dotIndex) : originalName;
            const ext = dotIndex !== -1 ? originalName.slice(dotIndex) : '';

            let name = `${base}(1)${ext}`;

            if (existingNames.has(name)) {
                let counter = 2;
                do {
                    name = `${base}(${counter})${ext}`;
                    counter++;
                } while (existingNames.has(name));
            }

            const renamedFile = new File([file], name, { type: file.type });
            updatedFiles.push(renamedFile);
            existingNames.add(name);
        }

        this.setState({ files: updatedFiles });
        this.validateFiles(updatedFiles);
    };

    validateFiles = (files) => {
        let totalFileSize = 0;
        files.forEach((file) => {
            let megabytes = (file.size / (1024 * 1024)).toFixed();
            totalFileSize = parseInt(totalFileSize) + parseInt(megabytes);
        });
        if (totalFileSize > MAX_TOTAL_MB) {
            this.setState({ validtoUpload: false });
        } else {
            this.setState({ validtoUpload: true });
        }
    };

    remove = (fileName) => {
        var filteredArray = this.state.files.filter((e) => e.name !== fileName);
        this.setState({
            files: filteredArray,
        });
        this.validateFiles(filteredArray);
    };

    render() {
        const { t, fetching, error } = this.props;
        const { showInvalid } = this.state;

        if (fetching && !error) {
            return (<Loading />)
        }
        if (showInvalid) {
            return (<ErrorPage/>)
        }

        const files = this.state.files.map((file) => (
            <tr key={file.name}>
                <td>
                    {file.name} - ({(file.size / (1024 * 1024)).toFixed(2)} MB)
                </td>
                <td>
                    <span
                        style={{ marginLeft: "100px", marginTop: "12px", cursor: "pointer" }}
                        onClick={() => this.remove(file.name)}
                    >
                        <FontAwesomeIcon icon={faTrash} />
                    </span>
                </td>
            </tr>
        ));

        return (
            <div className="full-background">
                <div className={"header-" + window.globalConfig.CustomerName + " container-fluid"}>
                    <div className="row align-items-center">
                        <div className="col-6 d-flex">
                            <div className="logo">
                                <Link to="/"><img src={this.state.portallogo} height="100%" alt="Portal Logo" /></Link>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="col-12 col-lg-12 mb-4">
                    <div className='text-center'>
                        <h2 className='create-case-ttl'>{this.state.createCaseHeader}</h2>
                        <p className='mb-4'>{this.state.createCaseFormInfo}</p>
                    </div>
                    <div className="box-container progressform mb-4">
                        <Form>
                            <Form.Row className="mb-3 creat-form-center">
                                <label column="true" sm={1} style={{ minWidth: '130px' }}>
                                    Sub Marketsource
                                </label>
                                <Col className="col-12 col-sm-8 col-md-7 col-lg-5 col-xl-4">
                                    <Form.Control
                                        as="select"
                                        onChange={this.handleSubMarketChange}
                                        value={this.state.selectedSubMarkets}
                                    >
                                        <option value="">{`-- ${t('optionName.select')} Sub Market --`}</option>
                                        {this.state.subMarketSourceValues.map((subMarket) => (
                                            <option key={subMarket.Id} value={subMarket.Id}>
                                                {subMarket.Name}
                                            </option>
                                        ))}
                                    </Form.Control>
                                </Col>
                            </Form.Row>

                            <Form.Row className="mb-3 creat-form-center">
                                <label column="true" sm={1} style={{ minWidth: "130px" }}>
                                    Skadebeskrivelse
                                    <span style={{ color: "red", marginLeft: "0.3rem" }}>*</span>
                                </label>
                                <Col className="col-12 col-sm-8 col-md-7 col-lg-5 col-xl-4">
                                    <Form.Control
                                        as="textarea"
                                        style={{ minHeight: "100px" }}
                                        placeholder=""
                                        onChange={this.handleDescription}
                                        value={this.state.description}
                                        required
                                    />
                                    {this.state.descriptionError && (
                                        <div style={{ color: "red" }}>Feltet er påkrevet</div>
                                    )}
                                </Col>
                            </Form.Row>

                            <Form.Row className="mb-3 creat-form-center">
                                <label column="true" sm={1} style={{ minWidth: "130px" }}>
                                    Skadenummer
                                    <span style={{ color: "red", marginLeft: "0.3rem" }}>*</span>
                                </label>
                                <Col className="col-12 col-sm-8 col-md-7 col-lg-5 col-xl-4">
                                    <Form.Control
                                        type="text"
                                        placeholder=""
                                        onChange={this.handleClaimNumber}
                                        value={this.state.claimNumber}
                                        required
                                    />
                                    {this.state.claimNumberError && (
                                        <div style={{ color: "red" }}>Feltet er påkrevet</div>
                                    )}
                                </Col>
                            </Form.Row>

                            <Form.Row className="mb-3 creat-form-center">
                                <label column="true" sm={1} style={{ minWidth: "130px" }}>
                                    Fornavn motpart   
                                </label>
                                <Col className="col-12 col-sm-8 col-md-7 col-lg-5 col-xl-4">
                                    <Form.Control
                                        type="text"
                                        placeholder=""
                                        onChange={this.handleCounterPartyFirstName}
                                        value={this.state.counterPartyFirstName}
                                    />
                                </Col>
                            </Form.Row>

                            <Form.Row className="mb-3 creat-form-center">
                                <label column="true" sm={1} style={{ minWidth: "130px" }}>
                                    Etternavn motpart
                                </label>
                                <Col className="col-12 col-sm-8 col-md-7 col-lg-5 col-xl-4">
                                    <Form.Control
                                        style={{ minHeight: "0" }}
                                        type="text"
                                        placeholder=""
                                        onChange={this.handleCounterPartySurname}
                                        value={this.state.counterPartySurname}
                                    />
                                </Col>
                            </Form.Row>

                            <Form.Row className="mb-3 creat-form-center">
                                <label column="true" sm={1} style={{ minWidth: "130px" }}>
                                    Motpartens ref
                                </label>
                                <Col className="col-12 col-sm-8 col-md-7 col-lg-5 col-xl-4">
                                    <Form.Control
                                        type="text"
                                        placeholder=""
                                        onChange={this.handleCoounterPartyRef}
                                        value={this.state.counterPartyRef}
                                    />
                                </Col>
                            </Form.Row>

                            <Form.Row className="mb-3 creat-form-center">
                                <Col md={5}>
                                    <Dropzone multiple={true} isDragActive={true} onDrop={this.onDrop}>
                                        {({ getRootProps, getInputProps }) => (
                                            <div className='caseFileDrop'>
                                                <div {...getRootProps()} style={{ border: '1px dashed #122e43', textAlign: 'center', width: "100%" }} className="fileDropd">
                                                    <input {...getInputProps()} />
                                                    <p>Last opp filer</p>
                                                </div>
                                                <aside style={{
                                                    maxHeight: '100px',
                                                    overflowY: 'scroll',
                                                    scrollbarWidth: 'none',
                                                    msOverflowStyle: 'none'
                                                }}>
                                                    <table style={{ width: '100%', borderCollapse: 'collapse', }}>
                                                        <tbody>{files}</tbody>
                                                    </table>
                                                </aside>
                                            </div>
                                        )}
                                    </Dropzone>
                                    {!this.state.validtoUpload && (
                                        <div style={{ color: "red" }}>
                                            Total filstørrelse kan ikke overstige {MAX_TOTAL_MB} MB
                                        </div>
                                    )}
                                </Col>
                            </Form.Row>

                            <Form.Row className="mb-3 text-uppercase pt-4 text-center">
                                <Button
                                    className="generalbtn pl-3 pr-3 pt-2 pb-2 m-auto"
                                    type="button"
                                    onClick={this.handleCreateFormSubmit}
                                    disabled={!this.state.validtoUpload}
                                >
                                    SEND INN
                                </Button>
                            </Form.Row>
                        </Form>                    
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    createcasedata: state.user.createcasedata,
    fetching: state.user.fetching,
    error: state.error.isError,
});

const mapDispatchToProps = {
    createCase,
    getPortalSettings,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(CreateCase)));
